import { PreferencesTab } from "@/components/profile/preferences-tab.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/settings/preferences")({
	component: PreferencesTab,
	head: () => ({
		meta: [{ title: pageTitle(m.settings_item_preferences()) }],
	}),
});
